import { HTMLAttributes, PropsWithChildren } from 'react';
import styles from './Card.module.css';
import { PropsWithClassName } from 'interfaces';
import classNames from 'classnames';

export const Card = ({
    children,
    className,
    ...rest
}: PropsWithChildren<PropsWithClassName & HTMLAttributes<HTMLDivElement>>) => {
    return (
        <div className={ classNames(styles.container, className) } { ...rest }>{ children }</div>
    );
};
